import React from "react";
import ChooserComponent from "./ChooserComponent.js";
import ComponentDisplay from "./ComponentDisplay.js";
export default function ConditionalDisplayChooser(props) {
    const { component, onChange, componentsList } = props;
    return (React.createElement("div", { id: component.id, className: props.isOutlined ? "flow-component-outlined" : "" },
        React.createElement(ChooserComponent, { component: {
                type: "chooser",
                direction: "horizontal",
                label: component.label,
                id: component.id,
                priority: "high-pr",
                fieldName: component.fieldName,
                options: component.options,
            }, isOutlined: false, onChange: onChange }),
        React.createElement("div", { className: "conditional-display-chooser-content-wrapper" }, component.options.map((option) => {
            var _a, _b;
            const isSelected = ((_b = (_a = props.form) === null || _a === void 0 ? void 0 : _a[component.id]) === null || _b === void 0 ? void 0 : _b.value) === option.name;
            if (componentsList[option.content].type === "empty-component")
                return React.createElement(React.Fragment, null);
            return (React.createElement("div", { key: option.id, className: "conditional-display-chooser-content" +
                    (isSelected ?
                        " conditional-display-chooser-content-selected"
                        : "") },
                React.createElement(ComponentDisplay, { component: componentsList[option.content], form: props.form, isOutlined: false, componentsList: props.componentsList, onChange: props.onChange })));
        }))));
}
